export const displaySizes = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    ALL: 'xs'
};
export const alignTypes = {
    BOTTOM: 'AlignBottom',
    CENTER: 'AlignCenter',
    MIDDLE: 'AlignMiddle',
    RIGHT: 'AlignRight',
    TOP: 'AlignTop'
};
export const spaceTypes = {
    AROUND: 'SpaceAround',
    BETWEEN: 'SpaceBetween'
};
export const GridColPosition = {
    FIRST: 'PositionFirst',
    LAST: 'PositionLast'
};
export default {
    displaySizes,
    alignTypes,
    spaceTypes
};
